<template>
  <div class="refund-wrap">
      <div class="backScreen" v-show="isBackShow"></div>
      <titleBar title="申请退费" @callback="goBack" :callback="true"></titleBar>
      <div class="refund-word">由于距购买年卡时间较长，费用无法按原支付路径返回。请填写下方信息，我们将直接把退款打到您的银行卡账户。</div>
      <div class="refund-form">
          <div class="form-title">-以下信息将为您加密处理，请放心填写-</div>
          <div class="form-input">
              <div class="title-name">银行卡号</div><input type="text" v-model="cardNumber" placeholder="只支持借记卡" class="inputcss" @keyup="handleCardNum()" @keypress="handlekeyPress()" maxlength="23"/>
          </div>
          <div class="form-input">
              <div class="title-name">户名</div><input type="text" v-model="account" align=“right” class="inputcss" @keyup="handleEmitFun()"/>
          </div>
          <div class="form-input">
              <div class="title-name">开户行</div><input type="text" v-model="bank" align=“right” class="inputcss" @keyup="handleEmitFun()"/>
          </div>
          <div class="form-input">
              <div class="title-name">手机号码</div><input type="text" v-model="contacts" align=“right” class="inputcss" maxlength="13" @keyup="handlePhoneNum()" @keypress="handlekeyPress()"/>
          </div>
      </div>
      <div class="refund-desc">
          <div class="desc-title">说明</div>
          <div class="desc-content">
              1：以上信息均为必填项。<br>
              2：银行卡只支持借记卡，请确保您的借记卡卡号输入正确。<br>
              3：申请成功后，退款将于3-15个工作日到账。<br>
              4：退款成功后，您的会员有效期和会员权益不会受到任何影响。<br>
              5：我们非常重视用户的隐私和个人信息保护，将严格依据法律法规规定对您的个人信息予以保护。
          </div>
      </div>
      <mt-button type='primary' :class="{'refund-but': true, 'active': isbutShow}" @click="handleFundClickFun">提交申请</mt-button>
  </div>
</template>

<script>
import titleBar from "@/components/common/titleBar.vue";
import utils from "@/assets/js/utils";
import ajax from "@/api/ajax";
import { Toast, Button } from 'mint-ui';
export default {
    name: "applyRefund",
    data() {
        return {
            token: "",
            cardNumber: "",
            account: "",
            bank: "",
            contacts: "",
            source: "",
            data: [],
            isBackShow: false,
            isbutShow: false
        }
    },
    components: {
        titleBar,
        Toast,
        Button
    },
    mounted() {
        this.token = utils.getQueryString("token");
        this.version = utils.getQueryString("version");
        this.source = utils.getQueryString("source");
        utils.sendLog({
          token: this.token,
          version: this.version,
          source: this.source
        }, 'hzxx3251');
    },
    methods: {
        // 限制数字空格
        handlekeyPress() {
            var myEvent = event || window.event;
            var keyCode = myEvent.keyCode;//这里做了兼容性处理
            if ((keyCode >= 48 && keyCode <= 57)){
                event.returnValue = true;
            } else {
                event.returnValue = false;
            }
        },
        // 返回页面
        goBack() {
            // let timestamp = Date.parse(new Date());
            // 返回新的打卡返年卡学习进度页面
            // window.history.go(-1)
            window.location.href = `hybird://method/exit`;
            // this.$router.push(`/card/studyProgress?source=${this.source}&token=${this.token}&version=${this.version}&random=${timestamp}`);
        },
        // 银行卡号
        handleCardNum() {
            this.handleEmitFun()
            this.cardNumber = this.cardNumber.replace(/(\d{4})(?=\d)/g, "$1 ");
        },
        // 户名
        handleNameFun() {
            this.handleEmitFun()
            // console.log('户名');
        },
        // 开户行
        handleBankDeposit() {
            this.handleEmitFun()
            // console.log('开户行');
        },
        // 手机号码
        handlePhoneNum() {
            this.handleEmitFun()
            this.contacts = this.contacts.replace(/\D/g, "").substr(0, 11);
            var len = this.contacts.length;
            if (len > 3 && len < 8) {
                this.contacts = this.contacts.substr(0, 3) + " " + this.contacts.substr(3);
            } else if (len >= 8) {
                this.contacts = this.contacts.substr(0, 3) + " " + this.contacts.substr(3, 4) + " " + this.contacts.substr(7);
            }
        },
        // 判断是否展示提交按钮
        handleEmitFun() {
            if (this.cardNumber && this.bank && this.account && this.contacts) {
                this.isbutShow = true
            } else {
                this.isbutShow = false
            }
        },
        // 申请退款
        handleReturnMoney: async function() {
            let self = this;
            var cardNum = self.cardNumber.replace(/\s/g,"");
            var phoneNum = self.contacts.replace(/\s/g,"");
            const [resp] = await ajax.all([
                ajax.post("/pay/return-money/apply", {
                    token: self.token,
                    cardNumber: cardNum,
                    account: self.account,
                    bank: self.bank,
                    contacts: phoneNum
                })
            ]);
            if (resp.data.code == 99999) {
                this.data = resp.data.data;
                this.isBackShow = true;
                Toast({
                    message: '提交成功',
                    position: 'middle',
                    duration: 3000
                });
                setTimeout(()=> {
                    this.isBackShow = false
                    this.$router.push({ path: '/card/refundProgress', query: {
                        token: this.token, version: this.version, source: this.source
                    }});
                }, 1000)
            } else {
                this.isBackShow = true;
                Toast({
                    message: resp.data.msg,
                    position: 'middle',
                    duration: 3000
                });
                setTimeout(()=> {
                    this.isBackShow = false
                }, 3000)
            }
        },
        // 点击事件
        handleFundClickFun() {
            // console.log('1212121')
            if (this.isbutShow) {
                utils.sendLog({
                token: this.token,
                version: this.version,
                source: this.source
                }, 'hzxx3252');
                this.handleReturnMoney();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.refund-wrap {
    background-color: #F4F4F4;
    margin-top: 0.88rem;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    .title-bar {
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
    }
    .refund-word {
        height: 1.26rem;
        width: 100%;
        font-size: .3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #424243;
        line-height: .42rem;
        padding: 0 .48rem;
        margin: .24rem 0 0 0;
        display: inline-block;
    }
    .refund-form {
        width: calc(100% - .8rem);
        margin: .48rem .4rem 0 .4rem;
        background: #FFFFFF;
        height: 5.41rem;
        padding: 0 .36rem;
        .form-title {
            font-size: .28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #919294;
            height: .96rem;
            line-height: .96rem;
            width: 100%;
            text-align: center;
            border-bottom: 2px dashed #e6e6e6;
        }
        .form-input {
            display: flex;
            flex-direction: row;
            border-bottom: 2px solid #f9f9f9;
            .title-name {
                height: 1.05rem;
                line-height: 1.05rem;
                font-size: .28rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #424243;
                margin-right: 16px;
                width: 1.5rem;
                word-break: break-all;
            }
            .inputcss {
                height: 1.05rem;
                line-height: 1.05rem;
                font-size: .28rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #919294;
                text-align: right;
                width: 100%;
            }
        }
    }
    .refund-desc {
        padding: .48rem .40rem;
        .desc-title {
            height: .45rem;
            font-size: .32rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: .45rem;
            margin-bottom: .28rem;
        }
        .desc-content {
            font-size: .28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #919294;
            line-height: .4rem;
        }
    }
    .refund-but {
        width: 6.70rem;
        height: .88rem;
        line-height: .88rem;
        display: block;
        background: #E2E4EA;
        border-radius: .44rem;
        font-size: .36rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        margin: 0 auto .37rem auto;
        cursor: pointer;
    }
    .active {
        background: #43A5F3;
    }
    .backScreen {
        position: absolute;
        height: 14.77rem;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 100;
        top: 0;
        left: 0;
    }
}
</style>
